import VisitaList from "./pages/VisitaList.vue"
import VisitaEdit from "./pages/VisitaEdit.vue"
import VisitaView from "./pages/VisitaView.vue"


export default {
    VisitaList,
    VisitaEdit,
    VisitaView,
  };